import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { retreive } from "../../actions/order";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Moment from "react-moment";
import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";

const Transaction = (props) => {
  const [values, setValues] = useState({
    orders: null,
  });
  useEffect(async () => {
    const orders = await props.retreive();
    window.scrollTo(0, 0);
    if (orders) {
      setValues({ ...values, orders: orders.reverse() });
    }
  }, []);

  return (
    <Fragment>
      <div className="transaction-wrapper wrapper-90 max-1600">
        <ul className="breadcrumb">
          <li>
            <Link to="/">
              <i className="fa fa-home" />
            </Link>
          </li>
          <li>
            <Link to="/dashboard"> / Account</Link>
          </li>
          <li>
            <Link to="/transactions"> / Transactions</Link>
          </li>
        </ul>
        <div className="container-fluid">
          <div className="row">
            <AccountLeftSidebar />
            <div className="col-md-9">
              <header className="transaction-header">
                <h3 className="transaction-title">Transactions</h3>
              </header>
              <div className="transaction-content">
                <div className="all-transactions-title">
                  <span>All Transactions</span>
                </div>
                <div className="transaction-table">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr className="transaction-tbl-header">
                          <th scope="col">
                            <div className="text-center">Date Added </div>
                          </th>
                          <th scope="col">
                            <div className="text-center">Descriptions</div>
                          </th>

                          <th scope="col">
                            <div className="text-center">
                              <span>Amount (USD)</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {values.orders &&
                          values.orders.length > 0 &&
                          values.orders.map((item, index) =>
                            item.paymentStatus &&
                            item.paymentStatus === "Ok" ? (
                              <tr className="transaction-tbl-body">
                                <td className="trans-td">
                                  <div className="transaction-date text-center">
                                    <span className="m-0">
                                      <Moment format="DD/MM/YYYY">
                                        {item.createdAt}
                                      </Moment>
                                    </span>
                                  </div>
                                </td>
                                <td className="trans-td text-center">
                                  <div className="transaction-discriptions ">
                                    {item.items.map((product, ind) => (
                                      <td key={ind}>
                                        <tr>
                                          <b>product Name</b> :
                                          {product && product.item.title}
                                        </tr>
                                        <tr>
                                          <b>Price</b> : {product.item.price}
                                        </tr>
                                        <tr>
                                          <b>Quantity</b> : {product.quantity}
                                        </tr>
                                      </td>
                                    ))}
                                  </div>
                                </td>

                                <td className="trans-td">
                                  <div className="transaction-amount text-center">
                                    <span>${item.amount}.00</span>
                                  </div>
                                </td>
                              </tr>
                            ) : null
                          )}
                        {values.orders && values.orders.length === 0 ? (
                          <tr>
                            <td className="text-center" colSpan="3">
                              {" "}
                              <b>No Any Transaction History</b>{" "}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

retreive.propTypes = {
  editNewsretreiveletter: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
});

export default connect(mapStateToProps, { retreive })(Transaction);
